
var jq224 = jQuery.noConflict(true);
jq224('.read-more-link').on('click', function(e){
    e.preventDefault();
    if (!jq224('#fullDescription').is(':visible')){
        jq224('#truncated').fadeOut(300, function(){
            jq224('#fullDescription').fadeIn(500);
        });
    }else{
        jq224('#fullDescription').fadeOut(300, function(){
            jq224('#truncated').fadeIn(500);
        });
    }
});
